export default {
  labels: {
    custom: 'Personalizat – Disponibil la cerere',
    was: 'Era {{amount}} – reducere anuală aplicată',
  },
  tags: {
    preferred: 'Deosebit de popular',
    net_one_time: 'net, o singură dată',
    annual_discount: '-{{percentage}}% anual',
  },
  buttons: {
    select_plan: 'Alege acest plan',
  },
};
